/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { PidxUtilsModule } from '@myprofile-ui/pidx-utils'
import { TranslatePipe } from '@ngx-translate/core'

@NgModule({
  imports: [CommonModule, TranslatePipe],
  exports: [ReactiveFormsModule, TranslatePipe, PidxUtilsModule],
})
export class SharedModule {}
